<template>
  <v-list-item-title style="position:relative;">
    <div>
      <ProfileChip class="mr-3" :item="item" />
      <span style="color:black">
      {{ item.properties.name }}
      </span>

    </div>
    <div>
      <NumberOfSchematisationChip v-if="!active" :number-of-schematisation="numberOfSchematisation" />
      <v-btn variant="flat" class="ml-3" append-icon="mdi-plus" v-if="active" size="x-small" color="primary"
             @click.stop="toggleDialog(); setCurrentSchematisation({dike_profile: item.id})">
        Add schematisation
      </v-btn>
    </div>

  </v-list-item-title>
</template>
<script>
  import { mapActions } from "vuex"
  import ProfileChip from "@/components/dike/ProfileChip.vue"
  import NumberOfSchematisationChip from "@/components/dikeProfile/NumberOfSchematisationChip.vue"

  export default {
    name: "DikeProfileIndexTitle",
    components: { NumberOfSchematisationChip, ProfileChip },
    props: {
      item: {},
      numberOfSchematisation: {},
      active: { type: Boolean, default: false }

    },

    methods: {
      ...mapActions("stabSchematisation", {
          toggleDialog: "toggleDialog",
          setCurrentSchematisation: "setCurrentItem"
        }
      ),
      ...mapActions("project", {
          getDikeProfileElevation: "getDikeProfileElevation"
        }
      )
    }

  }
</script>
<style scoped>

  .v-list-item-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    font-size: 12px;
    font-weight: 500;
    color: black;
  }

</style>
